/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
import { BaseController } from '../../BaseController';
import { GuaranteedRestoreTime } from '../../../model/GuaranteedRestoreTime';

class GuaranteedRestoreTimeViewController extends BaseController {
    /** @ngInject */
    constructor(configuration, notificationService, waitSpinnerService, $q, $state, $stateParams, $log,
        guaranteedRestoreTimeService, domainService, filterService, dateTimeService) {
        super(configuration, notificationService, waitSpinnerService, $q, $state, $stateParams, $log);
        this.guaranteedRestoreTimeService = guaranteedRestoreTimeService;
        this.domainService = domainService;
        this.filterService = filterService;
        this.dateTimeService = dateTimeService;
        this.$log.debug('Controller \'GuaranteedRestoreTimeView\' loaded');
    }

    $onInit() {
        super.$onInit();

        this.waitSpinnerService.visible = true;
        this.formDisabled = false;
        this.domains = [];
        this.days = new Array(7);
        this.grt = new GuaranteedRestoreTime();

        // The updateMode flag can be used to know the context in which this controller is running: creation or update.
        let initPromise;
        let domainPromise;
        if (this.$stateParams.hasOwnProperty('id')) {
            this.updateMode = true;
            this.title = 'ui.grt.update';
            initPromise = this.guaranteedRestoreTimeService.getEntity(this.$stateParams.id);
            domainPromise = [];
        } else {
            this.updateMode = false;
            this.title = 'ui.grt.creation';
            initPromise = this.$q.resolve();
            domainPromise = this.domainService.findEntities({
                params: this.filterService.buildSortingParam({sort: 'name'})
            });
        }

        this.handleRestServiceCall(this.$q.all({
            entity: initPromise,
            domains: domainPromise
        }), data => {
            if (data.entity) {
                data.entity.actionOpenTime = this.dateTimeService.parseTime(data.entity.actionOpenTime);
                data.entity.actionCloseTime = this.dateTimeService.parseTime(data.entity.actionCloseTime);
            }
            this.pristineEntity = new GuaranteedRestoreTime(data.entity);
            this.domains = data.domains;
            this.reset();
        }).finally(() => {
            this.waitSpinnerService.visible = false;
        });
    }

    /**
     * Maps a GRT object to the input format expected by the remote API, before a save request can be sent.
     *
     * @param {object} grt GuaranteedRestoreTime A GRT instance.
     */
    mapToDto(grt) {
        const convertedGrt = angular.copy(grt);
        convertedGrt.actionOpenTime = this.dateTimeService.formatTime(grt.actionOpenTime);
        convertedGrt.actionCloseTime = this.dateTimeService.formatTime(grt.actionCloseTime);
        // The actionDays property contains an array from 0 to 6, and a boolean value in each index tells whether the
        // day at this index is an action day.
        // The DTO must provide only an array with the number of each action days selected.
        // The following code filters the action days (true value), and pushes their indexes in the final array.
        // Indexes are incremented by 1 because first day of the week (monday) starts at index 1, as defined by the
        // remote REST interface.
        convertedGrt.actionDays = [];
        for (let i = 0; i < grt.actionDays.length; i++) {
            if (grt.actionDays[i]) {
                convertedGrt.actionDays.push(i + 1);
            }
        }
        return convertedGrt;
    }

    save() {
        this.formDisabled = true;
        const dto = this.mapToDto(this.grt);
        let serviceActionPromise;
        if (this.updateMode) {
            serviceActionPromise = this.guaranteedRestoreTimeService.updateEntity(dto);
        } else {
            serviceActionPromise = this.guaranteedRestoreTimeService.createEntity(dto);
        }
        this.handleRestServiceCall(serviceActionPromise, () => {
            const message = 'ui.grt.' + (this.updateMode ? 'updated' : 'created');
            this.notificationService.pushMessage(message, this.configuration.NOTIFIER_LEVEL_INFO);
            if (this.updateMode) {
                this.$state.reload();
            } else {
                this.$state.go('gmao.organization.grt.list');
            }
        }).finally(() => {
            this.formDisabled = false;
        });
    }

    getSetActionOpenTime(actionOpenTime) {
        if (actionOpenTime) {
            const time = this.dateTimeService.parseTime(actionOpenTime);
            if (time) {
                this.grt.setActionOpenTime(time);
            }
        }
        return this.dateTimeService.formatTime(this.grt.actionOpenTime);
    }

    getSetActionCloseTime(actionCloseTime) {
        if (actionCloseTime) {
            const time = this.dateTimeService.parseTime(actionCloseTime);
            if (time) {
                this.grt.setActionCloseTime(time);
            }
        }
        return this.dateTimeService.formatTime(this.grt.actionCloseTime);
    }

    reset() {
        this.grt = angular.copy(this.pristineEntity);
    }
}

export const guaranteedRestoreTimeViewComponent = {
    template: require('./guaranteedrestoretime-view.html'),
    controller: GuaranteedRestoreTimeViewController
};



// WEBPACK FOOTER //
// ./src/main/front/scripts/module/organization/component/GuaranteedRestoreTimeView.js